declare global {
  interface Window {
    electronAPI: {
      isElectronApp: () => boolean
      getAppVersion: () => Promise<string>
      checkForUpdates: () => void
      reload: () => void
      notify: ({ title, content, urgency }: { title: string; content: string; urgency?: string }) => void
      print: (htmlToPrint: string, options: any) => void
    }
  }
}

// our custom check
const isOnRecentCurecallElectronAppVersion = () => {
  return window?.['electronAPI']?.isElectronApp()
}

// fallback function
// see : https://stackoverflow.com/questions/61725325/detect-an-electron-instance-via-javascript
const detectElectronApp = () => {
  if (
    typeof window !== 'undefined' &&
    typeof (window as any).process === 'object' &&
    ((window as any).process as any).type === 'renderer'
  ) {
    return true
  }
  if (
    typeof (globalThis as any).process !== 'undefined' &&
    typeof (globalThis as any).process.versions === 'object' &&
    !!(globalThis as any).process.versions.electron
  ) {
    return true
  }
  if (
    typeof navigator === 'object' &&
    typeof navigator.userAgent === 'string' &&
    navigator.userAgent.indexOf('Electron') >= 0
  ) {
    return true
  }

  return false
}

const isOnElectronApp = () => {
  return isOnRecentCurecallElectronAppVersion() || detectElectronApp()
}

export { isOnElectronApp, isOnRecentCurecallElectronAppVersion }
